// Guests always open on the same area, so their points request is started at
// page load (before React mounts) and reused by the map's first fetch.
export const GUEST_CENTER = [30.302247, 78.067421]
export const GUEST_ZOOM = 17
const GUEST_TENANT_ID = "29"

// Degrees per pixel at the guest zoom (256px tiles)
const LNG_PER_PX = 360 / (256 * 2 ** GUEST_ZOOM)
const LAT_PER_PX = LNG_PER_PX * Math.cos((GUEST_CENTER[0] * Math.PI) / 180)

let prefetch = null // { bounds: {south, west, north, east}, promise }

const isGuestLoad = () =>
  new URLSearchParams(window.location.search).get("from_main_app") === "true" ||
  sessionStorage.getItem("isGuestUser") === "true"

export const startGuestPrefetch = () => {
  if (prefetch || !isGuestLoad()) return

  // Cover a large viewport (plus margin) so most screens fit inside it
  const halfW = (Math.max(window.innerWidth, 1920) / 2) * 1.2
  const halfH = (Math.max(window.innerHeight, 1080) / 2) * 1.2
  const bounds = {
    south: GUEST_CENTER[0] - halfH * LAT_PER_PX,
    north: GUEST_CENTER[0] + halfH * LAT_PER_PX,
    west: GUEST_CENTER[1] - halfW * LNG_PER_PX,
    east: GUEST_CENTER[1] + halfW * LNG_PER_PX,
  }

  const params = new URLSearchParams({
    southWestLat: bounds.south,
    southWestLng: bounds.west,
    northEastLat: bounds.north,
    northEastLng: bounds.east,
  })

  const promise = fetch(`${process.env.REACT_APP_API_BASE_URL}/points/public-visible/?${params}`, {
    headers: { "Tenant-ID": GUEST_TENANT_ID, "Content-Type": "application/json" },
  })
    .then((res) => (res.ok ? res.json() : null))
    .catch(() => null)

  prefetch = { bounds, promise }
}

// One-shot: returns the prefetched points if the map's view lies inside the
// prefetched area, otherwise null (caller then fetches normally).
export const consumeGuestPrefetch = async (leafletBounds) => {
  if (!prefetch) return null
  const { bounds, promise } = prefetch
  prefetch = null

  const sw = leafletBounds.getSouthWest()
  const ne = leafletBounds.getNorthEast()
  const inside = sw.lat >= bounds.south && sw.lng >= bounds.west && ne.lat <= bounds.north && ne.lng <= bounds.east
  return inside ? promise : null
}
